module.exports = __webpack_public_path__ + "static/media/extherm_at.4c8f481a.pdf";